import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { spUrl } from "utils/helpers";


const SPLink = ({ className, to, children, ...rest }) => (
	<Link className={className} to={spUrl(to)} {...rest}>{children}</Link>
);

SPLink.propTypes = {
	className: PropTypes.string,
	to: PropTypes.string.isRequired,
	children: PropTypes.node
};

export default SPLink;
